export const ADD_NEW_OBJECT_PROPS = 'ADD_NEW_OBJECT_PROPS'
export const LOAD_OBJECT_PROPS = 'LOAD_OBJECT_PROPS'
export const UNLOAD_OBJECT_PROPS = 'UNLOAD_OBJECT_PROPS'
export const EDIT_OBJECT_PROP = 'EDIT_OBJECT_PROP'
export const ADD_VALUE_IN_SIMP_PROPS = 'ADD_VALUE_IN_SIMP_PROPS'
export const ADD_VALUE_IN_MULT_PROPS = 'ADD_VALUE_IN_MULT_PROPS'
export const REMOVE_VALUE_IN_SIMP_PROPS = 'REMOVE_VALUE_IN_SIMP_PROPS'
export const REMOVE_VALUE_IN_MULT_PROPS = 'REMOVE_VALUE_IN_MULT_PROPS'
export const UNLOAD_UNPERSISTED_PROPS = 'UNLOAD_UNPERSISTED_PROPS'

export default {
	[ADD_NEW_OBJECT_PROPS] (state, payload) {
		state.list.push(payload)
	},
	[LOAD_OBJECT_PROPS] (state, payload) {
		state.list = payload.data
	},
	[UNLOAD_UNPERSISTED_PROPS] (state, payload) {
		state.list.splice(payload.index, 1)
	},
	[UNLOAD_OBJECT_PROPS] (state, payload) {
		state.list = payload.data
	},
	[EDIT_OBJECT_PROP] (state, payload) {
		state.list[payload.index] = payload.data
	},
	[ADD_VALUE_IN_SIMP_PROPS] (state, payload) {
		state.list[payload.index].data.valor = payload.data
	},
	[ADD_VALUE_IN_MULT_PROPS] (state, payload) {
		state.list[payload.index].data.valor = state.list[payload.index].data.valor || []
		state.list[payload.index].data.valor.push(payload.data)
	},
	[REMOVE_VALUE_IN_SIMP_PROPS] (state, payload) {
		state.list.splice(payload.propIndex, 1)
	},
	[REMOVE_VALUE_IN_MULT_PROPS] (state, payload) {
		state.list[payload.propIndex]
			.data.valor.splice(payload.valueIndex, 1)
	}
}
